export default "__VITE_ASSET__aa762ffe__"